export const formatNumber = number => {
  const kilo = number >= 1e3 && number < 1e6;
  const million = number >= 1e6 && number < 1e9

  if (number < 1e1) return number % 1 !== 0 ? number.toFixed(2) : number;
  if (number < 1e3) return number % 1 !== 0 ? Math.floor(number) : number;
  if (kilo) return + (number / 1e3).toFixed(1) + 'K';
  if (million) return + (number / 1e6).toFixed(1) + 'M';
}